import { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';
import { path } from 'ramda';

import { getDictionaries } from 'actions/asyncActions';

@withAsyncActions(({ dictionary }) => ({
    getDictionaries: getDictionaries
        .withOptions({ dispatchOnMount: !!dictionary })
}))
export default class DictField extends Component {
    static propTypes = {
        getDictionaries: PropTypes.object,
        value: PropTypes.string,
        dictionary: PropTypes.string,
    };

    render() {
        const { value, dictionary, getDictionaries: { data } } = this.props;
        const label = path([dictionary, value], data);

        return label || '';
    }
}



// WEBPACK FOOTER //
// ./src/components/common/fields/DictField.js